import React, { Component } from "react";
import {FaMusic, FaCalendar, FaLaptop, FaGuitar } from "react-icons/fa";
import Title from "./Title";
export default class Services extends Component {
  state = {
    services: [
      {
        icon: <FaMusic />,
        title: "To Artists",
        info:
          "We take pride in helping artists find the right studio and have an experience that is unique to each studio on saskia"
      },
      {
        icon: <FaCalendar />,
        title: "To studios",
        info:
          "We make it easy to List your studio and increase your bookings"
      },
      {
        icon: <FaLaptop />,
        title: "Sound Engineers",
        info:
          " We connect the best sound engineers to work on interesting projects with our listed studios"
      },
      {
        icon: <FaGuitar />,
        title: "Studio Store",
        info:
          "One stop online shop for  studio supplies"
      }
    ]
  };
  render() {
    return (
      <section className="services">
        <Title title="services" />
        <div className="services-center">
          {this.state.services.map(item => {
            return (
              <article key={`item-${item.title}`} className="service">
                <span>{item.icon}</span>
                <h6>{item.title}</h6>
                <p>{item.info}</p>
              </article>
            );
          })}
        </div>
      </section>
    );
  }
}
